import LoginModule from '../../components/LoginModule';
import AccountProfile from './AccountProfile';
import DocumentTitle from '../../DocumentTitle';
import { Blackjacklogo } from '../../ImageLoader';
import { useNavigate } from 'react-router-dom';
import AccountControls from '../../components/AccountControls';

const SESSION_STATE = {
    SESSION_WAITING : 0,
    SESSION_LOGGING_IN : 1,
    SESSION_LOGGED_IN : 2
}
const profileProps = {username : '', isPremium : false, isOptInMarketing : false,playerId : 0, isSubscriptionActive : false,isPaypalError : false};



function getTodaysDate()
{
    let currentDate = new Date();
    let cDay = currentDate.getDate();
    let cMonth = currentDate.getMonth() + 1;
    let cYear = currentDate.getFullYear();
    cMonth += 10;
    cDay += 10;
    return cYear+''+cMonth+''+cDay;
}

let sessionState = SESSION_STATE.SESSION_WAITING;
const Page_Manage_Games_Account = () => {
    const navigate = useNavigate();
    
    function setAccountValues(data) {
        profileProps.username = data.username;
        profileProps.isPremium = data.premiumExpireDate > getTodaysDate();
        profileProps.isOptInMarketing = data.isMarketingChecked;
        profileProps.playerId = data.playerId;
        profileProps.isSubscriptionActive = data.isSubscriptionActive;
        profileProps.isPaypalError = data.isAccountPPError;
        sessionState = SESSION_STATE.SESSION_LOGGED_IN;
        navigate('/manage-cwgames-account',{ replace: true });
    }

    if (sessionState === SESSION_STATE.SESSION_WAITING) {
        fetch('https://cwcreations.net/php/cwblackjackacc/query_user_session.php')
         .then((res) => res.json())
         .then((data) => {
            if (data.status === SESSION_STATE.SESSION_LOGGED_IN)
            {
                sessionState = SESSION_STATE.SESSION_LOGGED_IN;
                fetch('https://cwcreations.net/php/cwblackjackacc/query_user_session_data.php')
                    .then((res) => res.json())
                        .then((data) => {
                            setAccountValues(data);
                        });
            } else {
                sessionState = SESSION_STATE.SESSION_LOGGING_IN;
                navigate('/manage-cwgames-account',{ replace: true });
            }
         });
    }

    DocumentTitle("CW Creations - Dev Consult Share | Manage Your Account");

    switch(sessionState) {
        default: 
            return(<div id='ManageGamesAccount'><div id='manageGamesHeader'><img id='manageGamesLogo' src={Blackjacklogo}/>
                    <h2>Manage Account</h2></div></div>);
        case SESSION_STATE.SESSION_LOGGING_IN:
            return (<div id='ManageGamesAccount'><div id='manageGamesHeader'><img id='manageGamesLogo' src={Blackjacklogo}/>
                    <h2>Manage Account</h2></div>
                    <LoginModule reportResult={setAccountValues}/></div>);
        case SESSION_STATE.SESSION_LOGGED_IN:
            return (<div id='ManageGamesAccount'><div id='manageGamesHeader'><img id='manageGamesLogo' src={Blackjacklogo}/>
                        <h2>Manage Account</h2></div>
                        <div style={{'display':'flex','flexDirection':'column','rowGap':'35px','textAlign':'center'}}>
                            <AccountProfile props={profileProps}/><AccountControls profile={profileProps}/>
                        </div>
                    </div>);

    }
}


export default Page_Manage_Games_Account;